import templateUrl from './engagement-claim-modal.html'
import './engagement-claim-modal.scss'

const EngagementClaimModalComponent = {
  bindings: {
    projectId: '<',
    mode: '<'
  },
  require: {
    modalCtrl: '^^cdblModal'
  },
  templateUrl,
  controller: class EngagementClaimModal {
    constructor (Configuration, ProjectClaimsService, ProjectService, UserService) {
      'ngInject'
      this.Configuration = Configuration
      this.ProjectService = ProjectService
      this.ProjectClaimsService = ProjectClaimsService
      this.UserService = UserService
      this.loading = false
      this.error = null
    }

    $onInit () {
    }

    // Human-readable window for the pre-claim warning copy (e.g. "1 hour",
    // "90 minutes"). Null when the window is unknown.
    get claimExpiryLabel () {
      const minutes = this.ProjectClaimsService.claimExpiryMinutes
      if (!minutes) {
        return null
      }
      if (minutes % 60 === 0) {
        const hours = minutes / 60
        return `${hours} hour${hours === 1 ? '' : 's'}`
      }
      return `${minutes} minute${minutes === 1 ? '' : 's'}`
    }

    handleAction () {
      this.loading = true
      this.error = null

      const action = this.mode === 'claim'
        ? this.ProjectClaimsService.claimProject(this.projectId)
        : this.ProjectClaimsService.unclaimProject(this.projectId)

      action
        .then(response => {
          this.modalCtrl.resolve(response)
          Object.assign(this.ProjectService.project, { ...response.project, engagementClaims: response.engagementClaims })
          delete response.expert.id
          Object.assign(this.UserService.user, response.expert)
        })
        .catch(err => {
          this.error = err.message || 'An error occurred. Please try again.'
          console.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}

export default EngagementClaimModalComponent
